/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IObrienZendeskData } from './obrien-zendesk.data';
import { IObrienZendeskProps } from './obrien-zendesk.props.autogenerated';

export interface IObrienZendeskViewProps extends IObrienZendeskProps<IObrienZendeskData> {}

/**
 *
 * ObrienZendesk component
 * @extends {React.PureComponent<IObrienZendeskProps<IObrienZendeskData>>}
 */
class ObrienZendesk extends React.PureComponent<IObrienZendeskProps<IObrienZendeskData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default ObrienZendesk;
